import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  history: { isLoading: false, data: [] },
};

const userBalanceSlice = createSlice({
  name: 'userBalance',
  initialState,
  extraReducers: (builder) => builder,
});

export default userBalanceSlice.reducer;
